// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Mkhob","top":"styles_top__2BrHs","left":"styles_left__3Ccil","description":"styles_description__3Fhz_"};